import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextareaAutosize,
} from '@mui/material'
import React from 'react'

export function ErrorDialog({
  title,
  errors,
  onClose,
}: {
  title: string
  errors?: string[]
  onClose(): void
}) {
  if (!errors?.length) return null
  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextareaAutosize disabled={true} value={errors.join('\n')} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}
